import { useState, useEffect } from 'react';

const heroImages = [
  'https://public.readdy.ai/ai/img_res/a95383a77f32d648e7a01aa83c7b341e.jpg',
  'https://readdy.ai/api/search-image?query=Summer%20outdoor%20camp%20scene%20with%20students%20in%20jerseys%20gathering%20around%20campfire%20at%20mountain%20retreat%2C%20warm%20evening%20atmosphere%20with%20glowing%20fire%2C%20Japanese%20youth%20camp%20activity%20in%20forest%20clearing%2C%20natural%20lighting%20with%20golden%20hour%20glow&width=1920&height=1080&seq=hero2&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Group%20of%20students%20hiking%20on%20mountain%20trail%20in%20summer%2C%20wearing%20backpacks%20and%20outdoor%20gear%2C%20lush%20green%20forest%20scenery%20with%20sunlight%20filtering%20through%20trees%2C%20Japanese%20mountain%20hiking%20adventure%20with%20youth%20group%2C%20natural%20outdoor%20education%20setting&width=1920&height=1080&seq=hero3&orientation=landscape',
];

export default function HeroSection() {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % heroImages.length);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    }
  };

  return (
    <section className="relative h-screen min-h-[800px] overflow-hidden">
      {/* Background Images with Slideshow */}
      {heroImages.map((image, index) => (
        <div
          key={index}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            index === currentImageIndex ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <div
            className="absolute inset-0 bg-cover bg-center"
            style={{ backgroundImage: `url(${image})` }}
          />
        </div>
      ))}

      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-forest-900/40 via-forest-900/30 to-forest-900/40"></div>

      {/* Washi Paper Texture Overlay */}
      <div
        className="absolute inset-0 opacity-10"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='100' height='100' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' /%3E%3C/filter%3E%3Crect width='100' height='100' filter='url(%23noise)' opacity='0.4'/%3E%3C/svg%3E")`,
        }}
      ></div>

      {/* Content */}
      <div className="relative h-full flex items-center justify-center px-6">
        <div className="max-w-4xl text-center">
          <h1 className="font-serif text-white mb-6">
            <span className="block text-5xl md:text-7xl lg:text-8xl font-bold mb-4 tracking-wider">
              自然に包まれる
            </span>
            <span className="block text-4xl md:text-6xl lg:text-7xl font-bold tracking-wider">
              やすらぎの時間
            </span>
          </h1>

          <p className="text-white text-base md:text-lg lg:text-xl mb-8 font-sans font-light tracking-wide">
            兵庫県養父市ハチ高原のスキー場近くにある
            <br className="hidden md:block" />
            アットホームな和風民宿
          </p>

          <button
            onClick={() => scrollToSection('introduction')}
            className="inline-flex items-center px-8 py-3.5 bg-gold-600 text-white text-sm md:text-base font-medium rounded-full hover:bg-gold-700 transition-all duration-300 transform hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            詳しく見る
            <i className="ri-arrow-right-line ml-2"></i>
          </button>

          {/* Large Logo */}
          <div className="mt-16 md:mt-24">
            <h2 className="font-serif text-white text-6xl md:text-8xl lg:text-9xl font-bold tracking-widest opacity-90">
              あさぎり荘
            </h2>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
}